import { useEffect, useState } from "react";
import api from "../../../services/api";
import { getApiErrorMessage } from "../../../utils";
type Party = { id: string; name?: string; userName?: string; disabled?: boolean };
export function PartySelect({
  kind,
  value,
  onChange,
  label,
}: {
  kind: "user" | "system-user";
  value?: string;
  onChange: (value: string) => void;
  label: string;
}) {
  const [items, setItems] = useState<{ id: string; name: string }[]>([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    let cancelled = false;
    const timer = window.setTimeout(() => {
      setLoading(true);
      setError("");
      api
        .get<{ data: Party[]; totalPages: number }>(`/${kind}`, {
          params: { page, limit: 30, ...(kind === "user" ? { search } : {}) },
        })
        .then((res) => {
          if (!cancelled) {
            setItems(
              res.data.data
                .filter((item) => !item.disabled)
                .map((item) => ({
                  id: item.id,
                  name: item.userName ?? item.name ?? item.id,
                })),
            );
            setPages(res.data.totalPages || 1);
          }
        })
        .catch((err) => {
          if (!cancelled) setError(getApiErrorMessage(err));
        })
        .finally(() => {
          if (!cancelled) setLoading(false);
        });
    }, 250);
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [kind, search, page]);
  return (
    <fieldset className="space-y-1">
      <legend className="form-label">{label}</legend>
      {kind === "user" && (
        <input
          className="form-input"
          aria-label={`Buscar ${label}`}
          placeholder="Buscar contato"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />
      )}
      <select
        className="form-input"
        aria-label={label}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading}
      >
        <option value="">{loading ? "Carregando…" : "Não informado"}</option>
        {value && !items.some((item) => item.id === value) && (
          <option value={value}>Selecionado: {value}</option>
        )}
        {items.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
      {error && (
        <p role="alert" className="text-red-700 text-sm">
          {error}
        </p>
      )}
      {pages > 1 && (
        <div className="flex items-center gap-2 text-sm">
          <button
            type="button"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Anterior
          </button>
          <span>
            {page}/{pages}
          </span>
          <button
            type="button"
            disabled={page >= pages}
            onClick={() => setPage(page + 1)}
          >
            Próxima
          </button>
        </div>
      )}
    </fieldset>
  );
}
